// React
import React from 'react';
// Icons
import {
  IconBellRinging,
  IconCurrencyDollar,
  IconExclamationCircle,
  IconLicense,
} from '@tabler/icons-react';
// Components
import { DashboardChart } from './components/DashboardChart';
import { DashboardMetricsPanel } from './components/DashboardMetricsPanel';
import { useDashboardData } from './components/useDashboardData';

const icons = {
  claims: IconBellRinging,
  remittances: IconCurrencyDollar,
  submissions: IconLicense,
  error: IconExclamationCircle,
};

export const DashboardMetrics: React.FC = () => {
  const {
    metricData,
    statuses,
    chartData,
    startDate,
    endDate,
    setStartDate,
    setEndDate,
    isLoading,
    organization,
    loadingChart,
  } = useDashboardData();

  return (
    <>
      <DashboardMetricsPanel
        icons={icons}
        statuses={statuses}
        metricData={metricData}
        loading={isLoading}
      />

      <DashboardChart
        data={chartData}
        isLoading={loadingChart}
        startDate={startDate}
        endDate={endDate}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        organization={organization}
      />
    </>
  );
};
